var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { serializeError } from 'serialize-error';
function createConsoleLoggerFactory(wrappedMethodFactory, console) {
    if (console === void 0) { console = {
        enabled: true,
    }; }
    return function (methodName, logLevel, loggerName) {
        var rawMethod = wrappedMethodFactory(methodName, logLevel, loggerName);
        return function () {
            var message = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                message[_i] = arguments[_i];
            }
            if (console.enabled) {
                rawMethod.apply(void 0, __spreadArray(["".concat(new Date().toISOString(), " [").concat(methodName, "] ").concat(loggerName.toString(), ": ")], __read(message), false));
            }
        };
    };
}
function createHttpLoggerFactory(wrappedMethodFactory, _a) {
    var url = _a.url, _b = _a.batchCount, batchCount = _b === void 0 ? 10 : _b, _c = _a.intervalMillis, intervalMillis = _c === void 0 ? 10000 : _c, additionalFetchProperties = _a.additionalFetchProperties;
    var sendQueue = [];
    function evaluateSendQueue() {
        var batch = __spreadArray([], __read(Array(batchCount)), false).map(function () { return sendQueue.shift(); }).filter(function (body) { return !!body; });
        if (batch.length > 0) {
            fetch(url, __assign(__assign({ method: 'post' }, additionalFetchProperties), { headers: __assign(__assign({}, additionalFetchProperties === null || additionalFetchProperties === void 0 ? void 0 : additionalFetchProperties.headers), { 'Content-Type': 'application/json' }), body: JSON.stringify(batch, function (name, value) {
                    if (value instanceof Error) {
                        return serializeError(value);
                    }
                    return value;
                }) }));
        }
    }
    setInterval(evaluateSendQueue, intervalMillis);
    return function (methodName, logLevel, loggerName) {
        var rawMethod = wrappedMethodFactory(methodName, logLevel, loggerName);
        return function (message) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            sendQueue.push({ level: methodName, loggerName: loggerName, message: message, args: args });
            rawMethod.apply(void 0, __spreadArray([message], __read(args), false));
        };
    };
}
export { createConsoleLoggerFactory, createHttpLoggerFactory };
